import React,{useState,}from 'react'
import { Modal,Form,Input,message} from 'antd';
import { useBnsJiaoChengAddMutation, } from '../../store/ReactWebSiteApi';
import MyEditor from '../../cpn/MyEditor';
import { PlusSquareOutlined } from '@ant-design/icons';
import WebGoodsTypeSelect from '../goodsType/WebGoodsTypeSelect';
import SonTypeSelect from '../goodsType/SonTypeSelect';
import GetWebGoods from '../goods/GetWebGoods';
function TeachAdd() {    
    const [form] = Form.useForm();
    const [add]  = useBnsJiaoChengAddMutation()
    const [info,setInfo] = useState({
        bjc_content:'',
    });
    //返回详情
    const [open, setOpen] = useState(false);
    return (
            <>
                <a onClick={() => {setOpen(true)}}><PlusSquareOutlined /> 新增</a>
                <Modal
                    open={open}
                    title='新增'
                    okText="提交"
                    cancelText="取消"
                    onCancel={() => {setOpen(false);}}
                    width={1000}
                    onOk={() => {
                        add({
                            "bjc_cid" : localStorage.getItem('eu_id'),
                            "bjc_cname" : localStorage.getItem('eu_name'),
                            "bjc_content" : info.bjc_content,                            
                            "bjc_e_id" : localStorage.getItem('e_id'),
                            "bjc_name" : info.bjc_name,
                            "bjc_eowg_id" : info.bjc_eowg_id,
                            "bjc_eowg_name" : info.bjc_eowg_name,
                            "bjc_bg_id" : info.bjc_bg_id,
                            "bjc_bgn_id" : info.bjc_bgn_id,
                            "bjc_bgn_name" : info.bjc_bgn_name,
                            "bjc_bg_name" : info.bjc_bg_name,
                        }).then((res) => {
                            if (res.data.Status === 'success') {
                                message.info('新增成功！');
                                setOpen(false);
                            }
                            if (res.data.Status === "fail") {
                                message.error('新增失败！'+res.data.Message)
                            }
                        })     
                    }}
                >
                    <Form
                        form={form}
                        layout="horizonal"
                        name="form_client_add"
                        initialValues={{modifier: 'public',}}
                        labelCol={{ span: 3 }}                        
                    >
                        <WebGoodsTypeSelect
                            label='商品类型'
                            required
                            wrapperCol={{span:10}} 
                            onChange={(e,f) => {
                                setInfo(prevState=>({...prevState,bjc_bg_id:e,bjc_bg_name:f}))
                            }}  
                        />
                        <SonTypeSelect
                            label='子类型'
                            required
                            wrapperCol={{span:10}} 
                            onChange={(e,f) => {
                                setInfo(prevState=>({...prevState,bjc_bgn_id:e,bjc_bgn_name:f}))
                            }}  
                            eowgt_id={info.bjc_bg_id}
                        />
                        <GetWebGoods
                            label='商品'
                            required
                            wrapperCol={{span:10}} 
                            onChange={(e,f) => {
                                setInfo(prevState=>({...prevState,bjc_eowg_id:e,bjc_eowg_name:f}))
                            }}  
                            eowgt_id={info.bjc_bg_id}
                            eowgts_id={info.bjc_bgn_id}
                        />
                        <Form.Item name="name" label='名称' wrapperCol={{span:20}} required>
                            <Input 
                                onChange={(e) => {setInfo(prevState=>({...prevState,bjc_name:e.target.value}))}}
                            />
                        </Form.Item> 
                        <Form.Item name="remark" label='备注' wrapperCol={{span:20}}>
                            <MyEditor 
                                onChange={(e) => {setInfo(prevState=>({...prevState,bjc_content:e}))}}
                            />
                        </Form.Item> 
                    </Form>
                </Modal>
                </>
        )
}

export default TeachAdd